import React, { useEffect, useRef, useState } from 'react'; 

type Props = {
  position?:string;
  post:any;  
  payoutTimeString:any;
  className?:string;
  style?:any;
  dropdownStyle?:any;
  onNewError:Function; 
};

const RewardsButton = ({position="",post, payoutTimeString, onNewError,className, style, dropdownStyle }: Props) => {
  const [open, setOpen] = useState(false);  
  const menuRef = useRef<HTMLDivElement | null>(null); 
  useEffect(() => {
    try {
        const handleClickOutside = (event) => {
        const menuNode = menuRef.current;
        if (menuNode && !menuNode.contains(event.target)) {
            setOpen(false);
        }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    } catch (error) {
        onNewError(error)
    }
    
  }, []); 
  let reward_option = "";
  if (post.percent_steem_dollars == 0) {
    reward_option = "100% SP";
  }else{
    if (post.max_accepted_payout != '1000000.000 SBD') {
        reward_option = "Payment rejected";
    }else {
        reward_option = "50% SBD/50% SP";
    }
  }

  let isExpired = payoutTimeString.includes("Paid")?true:false;
  let total_payout_value = 0;
  let curator = 0;
  let author = 0;
  let promotion = 0;
  if (isExpired) {
    curator = parseFloat(post.curator_payout_value);
    author  = parseFloat(post.total_payout_value || post.author_payout_value || 0);
    total_payout_value = curator + author;
    
  }else {
    total_payout_value = parseFloat(post.pending_payout_value);
    curator = 0.5 * total_payout_value;
    author = 0.5 * total_payout_value;
  }

  if (post?.promoted) {
    promotion += parseFloat(post?.promoted);
  }

  let benef_weight = 0;

  if (post.beneficiaries) {
    for (let i = 0; i < post.beneficiaries.length; i++) {
        const element = post.beneficiaries[i];
        benef_weight += parseFloat(element.weight);
    }
  }

  let benef_rewards = author * benef_weight / 10000;
  author -= benef_rewards;

  return (
    <div ref={menuRef} className={`relative d-inline-block ${open ? 'menu-open' : ''}`}>
      {className == "swipe-rewards" && (
        <div className="swipe-action-item">
          <button
            className="swipe-btn swipe-up"
            onClick={() => { setOpen(!open);}}
          >
            <i className="fas fa-dollar" />
          </button>
          <a className={`swipe-action-text ${className || ""} `} style={{cursor:"pointer"}} onClick={() => { setOpen(!open);}}>
          {(total_payout_value).toFixed(2)}
          </a>
        </div> 
      )}
      {className != "swipe-rewards" && (
        <button 
          className={`btn ${className?.includes('no-pill') ? '' : 'reward-action-btn'} ${className || ""}`} 
          style={style} 
          onClick={() => setOpen(!open)}
        >
          <i className="fas fa-dollar-sign mr-1" /> {(total_payout_value).toFixed(2)} <i className="fas fa-caret-down ml-1" />
        </button> 
      )}
      
      {open && (
        <div className={`absolute text-left dropdown-window rewards-popup-window ${position}`} title={payoutTimeString} style={dropdownStyle}>
            <div className="rewards-header">
              <span className="rewards-total-label">Total Payout</span>
              <span className="rewards-total-value">${(total_payout_value).toFixed(2)}</span>
            </div>

            <div className="rewards-body">
              <div className="reward-row">
                <span className="reward-label">Author</span>
                <span className="reward-value">${(author).toFixed(2)}</span>
              </div>
              <div className="reward-row">
                <span className="reward-label">Curators</span>
                <span className="reward-value">${(curator).toFixed(2)}</span>
              </div>
              {promotion > 0 && (
                <div className="reward-row">
                  <span className="reward-label">Promotion</span>
                  <span className="reward-value">${(promotion).toFixed(3)}</span>
                </div>
              )}
            </div>

            {(post.beneficiaries && post.beneficiaries.length > 0) && (
                <div className="rewards-beneficiaries">
                    <div className="reward-row benef-total">
                      <span className="reward-label">Beneficiaries</span>
                      <span className="reward-value">${(benef_rewards).toFixed(2)}</span>
                    </div>
                    <ul className="benef-list">
                    {post.beneficiaries.map((b) => (
                        <li key={`${b.account}-${b.weight}`}>
                           <a href={`/u/${b.account}`} className="benef-account">@{b.account}</a> 
                           <span className="benef-pct">{(b.weight / 100).toFixed(0)}%</span>
                        </li>
                    ))}
                    </ul>
                </div>
            )} 

            <div className="rewards-footer">
              <span className="reward-time text-muted"><i className="far fa-clock mr-1" />{payoutTimeString}</span>
              <span className="reward-option">{reward_option}</span>
            </div>
        </div>
      )}
      
    </div>
    
  );
};

export default RewardsButton;
